import React from "react";
import {FormikProps} from "formik";
import {FormControl, FormHelperText, InputLabel, Select, styled} from "@mui/material";
import {SelectProps} from "@mui/material/Select/Select";
import {HELPER_TEXT_STYLES} from "./variable";
import {get} from "lodash";
import getCompleteFieldName from "./factory/helper";

export interface FormSelectFieldProps<T> extends Omit<SelectProps, "labelId" | "name"> {
    fieldName: keyof T;
    subFieldName?: string;
    label: string;
    form: FormikProps<T>;
    children: React.ReactNode | React.ReactNode[];
}

const StyledSelectField = styled(Select)`
    .MuiFormHelperText-root {
        ${HELPER_TEXT_STYLES}
    }
`;

const FormSelectField = <T,>({
    fieldName,
    subFieldName,
    label,
    form,
    children,
    required,
    ...rest
}: FormSelectFieldProps<T>) => {
    const name = getCompleteFieldName(fieldName, subFieldName);
    return (
        <FormControl fullWidth error={form.touched[fieldName] && Boolean(form.errors[fieldName])} required={required}>
            <InputLabel id={`${name}-label`}>{label}</InputLabel>
            <StyledSelectField
                label={label}
                labelId={`${name}-label`}
                name={name}
                value={get(form.values, name)}
                onChange={rest.onChange ?? form.handleChange}
                variant={"outlined"}
                fullWidth
                {...rest}
            >
                {children}
            </StyledSelectField>
            {form.touched[fieldName] && (
                <FormHelperText>{form.errors[fieldName] && String(form.errors[fieldName])}</FormHelperText>
            )}
        </FormControl>
    );
};

export default FormSelectField;
